import React from 'react';
import { Box, alpha, CardHeader, CardContent } from '@mui/material';
import { COLORS, ModernCard } from '../../../../pages/Organisation/DailyUpdates/utils';

const OrganisationAdminSkeleton = () => {
	return (
		<Box
			sx={{
				p: 3,
				maxWidth: '1400px',
				margin: '0 auto',
				backgroundColor: alpha(COLORS.neutral, 0.5),
				borderRadius: '24px'
			}}
		>
			{/* Staff Invited Card Skeleton */}
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2, 3].map((index) => (
								<Box
									key={index}
									sx={{ p: 2, borderRadius: '8px', bgcolor: alpha(COLORS.neutralDark, 0.3) }}
								>
									<Box
										sx={{
											width: '70%',
											height: '20px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1,
											mb: 1
										}}
									/>
									<Box
										sx={{
											width: '30%',
											height: '14px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>
			</Box>

			{/* Staff Role Updates Card Skeleton */}
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2].map((index) => (
								<Box
									key={index}
									sx={{ p: 2, borderRadius: '8px', bgcolor: alpha(COLORS.neutralDark, 0.3) }}
								>
									<Box
										sx={{
											width: '60%',
											height: '20px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1,
											mb: 1
										}}
									/>
									<Box
										sx={{
											width: '50%',
											height: '16px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1,
											mb: 1
										}}
									/>
									<Box sx={{ pl: 2 }}>
										{[1, 2].map((roleIndex) => (
											<Box key={roleIndex} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
												<Box
													sx={{
														width: '6px',
														height: '6px',
														borderRadius: '50%',
														bgcolor: COLORS.neutralDark,
														mr: 1
													}}
												/>
												<Box
													sx={{
														width: '40%',
														height: '14px',
														bgcolor: COLORS.neutralDark,
														borderRadius: 1
													}}
												/>
											</Box>
										))}
									</Box>
									<Box
										sx={{
											width: '30%',
											height: '14px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1,
											mt: 2
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>
			</Box>
		</Box>
	);
};

export default OrganisationAdminSkeleton;
